import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92fd0ae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chip-input", { checked: _ctx.isChecked }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clicked()))
  }, [
    _createElementVNode("label", {
      class: "label-chip",
      for: _ctx.id
    }, _toDisplayString(_ctx.label), 9, _hoisted_1)
  ], 2))
}